export default "__VITE_ASSET__DDSfeiHN__"